import React, {useEffect, useState} from "react";
import Header from "../../component/Header/Header";
import {useSelector} from "react-redux";
import QuantitySelector from "../../component/quantitySelector";
import protonIconOffer from '../../../shared/assets/icons/proton-icon-offer.svg'
import tireFinderWarranty from '../../../shared/assets/icons/icon-tire-finder-warranty.svg'
import QuoteButton from "../../component/quoteButton";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import Dialog from "@material-ui/core/Dialog";
import Slide from "@material-ui/core/Slide";
import Offer from "../../component/Offers/offer";
import Analytics from "../../../shared/util/analytics";
import protonIconOfferRed from "../../../shared/assets/icons/proton-icon-offer-red.svg";


const transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});

const ProductDetail =() => {
    const tires = useSelector(state => state.searchResultReducer.filteredResults);
    const tireIndex = useSelector(state => state.searchResultReducer.detailIndex);
    const adobeFlag = useSelector(state => state.appParamsReducer.adobeScriptLoadFlag);
    const [open, setOpen] = useState(false);
    const analytics = Analytics();
    const brand = useSelector(state => state.appParamsReducer.brand);


    useEffect(() => {
        if (adobeFlag) {
            analytics.trackPage('product-detail');
            // eslint-disable-next-line no-undef
            _satellite.track('product-detail');
            console.log('Analytics Added for Page to DOM: Product Detail using JQuery');
        }
        // eslint-disable-next-line
    }, [adobeFlag]);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    function RenderAsBullets(props) {
        let notes = props.description.split('*$*');
        notes = notes.splice(0, notes.length - 1)
        const bulletNotes = notes.map((note) =>
            <li key={note}>{note}</li>
        );
        return (<ul className={'notesContent'}>{bulletNotes}</ul>);
    }


    return (
        <>
            <Offer/>
            <br/>
            <Header title='Search Results' page='/searchResult' viewQuote={true}/>
            <div className={'container'}>
                <div className={'helpText'}>{tires[tireIndex].brand}</div>
                    <div className={'searchHeaderDetail'}>{tires[tireIndex].name}</div>
                    <br/>
                    <div className={'helpText'}>{tires[tireIndex].originalEquipment === true?
                            <div className={"tireBrand"}>Original Equipment</div>:
                            <div className={"tireBrand"}>Replacement Tire</div>
                    }</div>
                <br/>
                <div className={'hide-on-mobile'}>
                <div className={'quantityFlexProduct'}>
                    <div className={"tireImage"}><img src={"../tirefinder/api/v1/blob/" + tires[tireIndex].imageName}
                                                      alt="Tire"/></div>
                    <div className={"quantityRight"}>
                    <QuantitySelector brand={tires[tireIndex].brand} tireName={tires[tireIndex].name} gmPartNum={tires[tireIndex].gmPartNum} priceFailed={tires[tireIndex].priceFailed} page='search' displayBelow={false}/>
                    <br/>
                    <div className={'descriptionDetail'}>{tires[tireIndex].brandDescription}</div>
                        <br/>
                        <div className={'detailWarranty'}>
                            <img src={tireFinderWarranty} alt={'Offer Tag'}/>{ isNaN(parseInt(tires[tireIndex].warranty, 10))? tires[tireIndex].warranty: tires[tireIndex].warranty + " mile warranty"}
                        </div>
                        <div className={'detailOfferContainer'}>
                            {tires[tireIndex].primaryOfferDetails !== null?
                                <div className={'resultsOffers stat-text-link'} data-dtm={tires[tireIndex].brand + ':' + tires[tireIndex].name + ':' + tires[tireIndex].primaryOfferDetails}>
                                <div>
                                    {brand ==='gmc' ? <img src ={protonIconOfferRed} alt ={'Offer Tag'} />
                                        :   <img src={protonIconOffer} alt={'Offer Tag'}/>}</div>
                                <div>{tires[tireIndex].tireFinderPromoTitle}</div>
                                <div><u style={{cursor: 'pointer'}} onClick={handleClickOpen}>Details</u></div>
                                </div>:null}
                            <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={transition}>
                                <Toolbar>
                                    <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
                                        <CloseIcon/>
                                    </IconButton>
                                </Toolbar>
                                <Container maxWidth="lg">
                                    <Typography variant="h2" gutterBottom>{tires[tireIndex].tireFinderPromoTitle}</Typography>
                                    <Typography variant="body1"
                                                gutterBottom>{tires[tireIndex].primaryOfferDetails}</Typography>
                                    <Typography variant="body1"
                                                gutterBottom>{`Offer begins on ${tires[tireIndex].effectiveDate} and ends on ${tires[tireIndex].expirationDate}`}</Typography>
                                </Container>
                            </Dialog>
                        </div>
                    </div>
                </div>
                <br/>
                <div className={'detailQuote'}>
                <QuoteButton gmPartNum={tires[tireIndex].gmPartNum}/>
                </div>
                <br/>
                </div>

                <div className={'hide-on-desktop'}>
                    <div className={'desktopCardFlex'}>
                        <div className={'desktopTire'}>
                            <div className={"tireImage"}><img src={"../tirefinder/api/v1/blob/" + tires[tireIndex].imageName}
                                                              alt="Tire"/>
                            </div>
                        </div>
                        <div className={'desktopContent'}>
                                <div className={'desktopQuantity'}>
                                    <QuantitySelector gmPartNum={tires[tireIndex].gmPartNum} priceFailed={tires[tireIndex].priceFailed} page='search' displayBelow={false}/>
                                </div>
                        <br/>
                        <div className={'description'}>{tires[tireIndex].brandDescription}</div>
                        <br/>
                        <div className={"desktopButton"}>
                            <QuoteButton gmPartNum={tires[tireIndex].gmPartNum}/>
                        </div>
                            <br/>
                            <div className={'detailPhone'}>
                                <div><img src={tireFinderWarranty} alt={'Offer Tag'}/></div>
                                <div className={'helpText'}>
                                    { isNaN(parseInt(tires[tireIndex].warranty, 10))? tires[tireIndex].warranty: tires[tireIndex].warranty + " mile warranty"}
                                </div>
                            </div>
                            {tires[tireIndex].primaryOfferDetails !== null?
                            <div className={'detailOfferContainer stat-text-link'} data-dtm={tires[tireIndex].brand + ':' + tires[tireIndex].name + ':' + tires[tireIndex].primaryOfferDetails}>
                                        <div>{brand ==='gmc' ? <img src ={protonIconOfferRed} alt ={'Offer Tag'} />
                                            :   <img src={protonIconOffer} alt={'Offer Tag'}/>}</div>
                                        <div className={'resultsOffers'}>{tires[tireIndex].tireFinderPromoTitle + '  '}
                                              <u style={{cursor: 'pointer'}} onClick={handleClickOpen}>Details</u>
                                        </div>
                                    </div>:null}
                                <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={transition}>
                                    <Toolbar>
                                        <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
                                            <CloseIcon/>
                                        </IconButton>
                                    </Toolbar>
                                    <Container maxWidth="lg">
                                        <Typography variant="h2" gutterBottom>{tires[tireIndex].tireFinderPromoTitle}</Typography>
                                        <Typography variant="body1"
                                                    gutterBottom>{tires[tireIndex].primaryOfferDetails}</Typography>
                                        <Typography variant="body1"
                                                    gutterBottom>{`Offer begins on ${tires[tireIndex].effectiveDate} and ends on ${tires[tireIndex].expirationDate}`}</Typography>
                                    </Container>
                                </Dialog>
                            </div>
                    </div>
                </div>

                <br/>
                <div className={'desktopFlex'}>
                <div className={'detailBox'}>
                    <div className={'detailHeader'}>Details</div>
                    <div>
                            <div className={'detailFlex'}>
                                <div className={'detailLabel'}>Tire Size</div>
                                <div className={'detailValue'}>{tires[tireIndex].tireSize}</div>
                            </div>
                            <div className={'detailFlex'}>
                                <div className={'detailLabel'}>Type</div>
                                <div className={'detailValue'}>{tires[tireIndex].tireType}</div>
                            </div>
                            <div className={'detailFlex'}>
                                <div className={'detailLabel'}>Sidewall</div>
                                <div className={'detailValue'}>{tires[tireIndex].sidewall}</div>
                            </div>
                            <div className={'detailFlex'}>
                                <div className={'detailLabel'}>Load Index</div>
                                <div className={'detailValue'}>{tires[tireIndex].load}</div>
                            </div>
                            <div className={'detailFlex'}>
                                <div className={'detailLabel'}>Speed Rating</div>
                                <div className={'detailValue'}>{tires[tireIndex].speedRating}</div>
                            </div>
                            <div className={'detailFlex'}>
                                <div className={'detailLabel'}>Load Range</div>
                                <div className={'detailValue'}>{tires[tireIndex].ply}</div>
                            </div>
                            <div className={'detailFlex'}>
                                <div className={'detailLabel'}>GM Part Number</div>
                                <div className={'detailValue'}>{tires[tireIndex].gmPartNum}</div>
                            </div>
                    </div>
                </div>
                <div className={'notesBox'}>
                    <div className={'detailHeader'}>Manufacturer Notes</div>
                    <div className={'notesContent'}><RenderAsBullets description={tires[tireIndex].description}/>
                        </div>
                </div>
                </div>
            </div>

        </>
    );
}

export default ProductDetail;
